var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper d-inline-flex align-center" },
    [
      _vm._l(Array(5), function (_, index) {
        return _c(
          "v-icon",
          { key: index, attrs: { color: "rgba(246, 177, 0)" } },
          [_vm._v("\n        " + _vm._s(_vm.renderStarIcon(index)) + "\n    ")]
        )
      }),
      _vm._v(" "),
      _c("h5", { staticClass: "mx-1" }, [
        _vm._v("(" + _vm._s(_vm.rating) + ")"),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }